import {
  parseArraySOC,
  parseBooleanEnabledSOC,
  parseNumberSOC,
} from "chat/imports/state";

export const getIsChatDeleteMessageEnabled = parseBooleanEnabledSOC(
  "web.chats.message.delete.action.enabled",
  "0"
);

export const getIsChatEditMessageEnabled = parseBooleanEnabledSOC(
  "web.chats.message.edit.action.enabled",
  "0"
);

export const getIsChatSaveMediaEnabled = parseBooleanEnabledSOC(
  "web.chats.media.save.action.enabled",
  "0"
);

export const getIsMessageReadIndicatorEnabled = parseBooleanEnabledSOC(
  "web.chats.message.read.indicator.enabled",
  "0"
);

export const getIsCopyMessageEnabled = parseBooleanEnabledSOC(
  "web.chats.message.copy.action.enabled",
  "0"
);

export const getIsPinChatEnabled = parseBooleanEnabledSOC(
  "web.chats.pin.action.enabled",
  "0"
);

export const getIsChatMenuEnabled = parseBooleanEnabledSOC(
  "web.chats.conversation.menu.enabled",
  "0"
);

export const getIsMuteChatEnabled = parseBooleanEnabledSOC(
  "web.chats.conversation.mute.enabled",
  "0"
);

export const getIsChatEventsEnabled = parseBooleanEnabledSOC(
  "web.chats.events.enabled",
  "0"
);

export const getIsDeleteChatEnabled = parseBooleanEnabledSOC(
  "web.chats.delete.action.enabled",
  "0"
);

export const getIsVoiceMessageEnabled = parseBooleanEnabledSOC(
  "chats.voice.message.enabled",
  "0"
);

export const getChatVoiceRecordEnabled = parseBooleanEnabledSOC(
  "web.chats.voice.record.enabled",
  "0"
);

export const getChatVoiceMaxDurationSeconds = parseNumberSOC(
  "web.chats.voice.max.duration.seconds",
  "300"
);

export const getIsMessageReactionsEnabled = parseBooleanEnabledSOC(
  "web.chats.message.reactions.enabled",
  "0"
);

export const getIsScrollToNewMessagesEnabled = parseBooleanEnabledSOC(
  "web.chats.scroll.to.new.messages.enabled",
  "0"
);

export const getChatSendVideoEnabled = parseBooleanEnabledSOC(
  "web.chat.send.video.enabled",
  "0"
);

export const getIsMessageAnimationEnabled = parseBooleanEnabledSOC(
  "web.chats.message.animation.enabled",
  "0"
);

export const getIsChatLiveBarEnabled = parseBooleanEnabledSOC(
  "web.chats.live.bar.enabled",
  "0"
);

export const getChatLiveBarModerationLevel = parseNumberSOC(
  "web.chats.live.bar.moderation.level",
  "5"
);

export const getIsChatAutoTranslationEnabled = parseBooleanEnabledSOC(
  "web.chats.auto.translation.enabled",
  "0"
);

export const getChatAutoTranslationSupportedIds = parseArraySOC(
  "web.chats.auto.translation.supported.ids",
  ""
);

export const getChatAutoTranslationThresholdDay = parseNumberSOC(
  "web.chats.auto.translation.threshold.days",
  "0"
);

export const getIsChatAudioMessageTranscriptionEnabled = parseBooleanEnabledSOC(
  "web.chats.audio.message.transcription.enabled",
  "0"
);

export const getIsChatAudioMessageTranscriptionRatingEnabled =
  parseBooleanEnabledSOC(
    "web.chats.audio.message.transcription.rating.enabled",
    "0"
  );

export const getIsSecureContentRetryEnabled = parseBooleanEnabledSOC(
  "web.chats.securecontent.retry.enabled",
  "0"
);
